import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const setupTurnTrackerRoutes = {
  name: 'turn-tracker-setup',
  path: 'setup/turn-tracker',
  component: () => import('./SetupTurnTracker.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
